import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["baseRoleRadio", "adminRoleCheckbox"]

  connect() {
    this.previousChecked = this.baseRoleRadioTargets.find(radio => radio.checked)?.value
    this.toggleAdminRoles()
  }

  toggleAdminRoles() {
    const current = this.baseRoleRadioTargets.find(radio => radio.checked)?.value
    const previous = this.previousChecked

    const isSuperAdmin = current === "super_admin"
    const wasSuperAdmin = previous === "super_admin"

    this.adminRoleCheckboxTargets.forEach(cb => {
      if (isSuperAdmin) { cb.checked = true }
      if (wasSuperAdmin && !isSuperAdmin) { cb.checked = false }

      cb.readonly = isSuperAdmin
      const controller = this.application.getControllerForElementAndIdentifier(
        cb.closest("label"), 'checkbox')
      if (controller) { controller.readonlyValue = isSuperAdmin }
    })

    this.previousChecked = current
  }
}
